import { useId } from "react";
import { G } from "./geometry.js";

/**
 * Under-32px variant. Identical silhouette; pupil removed (eye white r9),
 * mouth stroke 5 (dropped at 16px and below), blush dropped.
 */
export function PandaMarkCompact({ size = 24, ink = "#000000", face = "#FFFFFF", title = undefined, ...rest }) {
  const id = useId().replace(/:/g, "");
  const a11y = title ? { role: "img", "aria-labelledby": `${id}-t` } : { "aria-hidden": "true", focusable: "false" };
  const { face: f, earL, earR, patchL, patchR, eyeL, eyeR, nose } = G;
  return (
    <svg width={size} height={size} viewBox={G.viewBox} xmlns="http://www.w3.org/2000/svg" {...a11y} {...rest}>
      {title && <title id={`${id}-t`}>{title}</title>}
      <circle {...f} fill={face} />
      <circle {...earL} fill={ink} />
      <circle {...earR} fill={ink} />
      <circle {...patchL} fill={ink} />
      <circle {...patchR} fill={ink} />
      <circle cx={eyeL.cx} cy={eyeL.cy} r={G.compact.eyeR} fill={face} />
      <circle cx={eyeR.cx} cy={eyeR.cy} r={G.compact.eyeR} fill={face} />
      <ellipse {...nose} fill={ink} />
      {size > 16 && <path d={G.mouth} fill="none" stroke={ink} strokeWidth={G.compact.mouthStroke} />}
    </svg>
  );
}

export default PandaMarkCompact;
